<template>
  <div>
    <b-form-group v-bind:label="this.Datafield.label" v-bind:description="this.Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" required v-bind:name="this.Datafield.name"  v-bind:placeholder="this.Datafield.label" v-model="this.Datadata"></b-form-input>
    </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'inputPassword',
  props: {
    field: { required: true },
    data: { required: true }
  },
  data: function () {
    return {
      Datafield: {},
      Datadata: ''
    }
  },
  mounted () {
    this.Datafield = this.field
    this.Datadata = this.data
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputPassword.vue